import { render } from "./CompanyAwardsView.vue?vue&type=template&id=72dab8b7&scoped=true"
import script from "./CompanyAwardsView.vue?vue&type=script&lang=js"
export * from "./CompanyAwardsView.vue?vue&type=script&lang=js"

import "./CompanyAwardsView.vue?vue&type=style&index=0&id=72dab8b7&lang=scss&scoped=true"

import exportComponent from "/Users/mmessick/Sites/kiosk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dab8b7"]])

export default __exports__